import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import { connect } from 'react-redux';
import {
  saveGenericVAS,
  checkUserStatus,
  setTermAgreement,
  setIsShowConfirmTermsMsg,
  setIsShowConfirmPopUpTermsMsg,
  setErrorConfirmPopUpTermsMsg,
  reportAnalytics,
  reportDWH,
  changeEmailInputHandler,
  setIsValidEmail,
  setIsInstallSocsClicked,
  sendEmailHaveEsim,
  resetState,
} from './GenericVasSlice';
import { getRecaptchaToken } from '../../../utilities/recaptcha/recaptcha';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import CheckBox from '../../Shared/CheckBox/Checkbox';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';
import FailureScreen from '../../Shared/FailureScreen/FailureScreen';
import InstallSuccess from './InstallSuccess/InstallSuccess';
import TextInput from '../../Shared/TextInput/TextInput';
import { Row, Col } from 'reactstrap';
import PopUp from '../../Shared/Popup/PopUp';
import PopUpWhatIsEsim from '../../Block/SaleBlock/Esim/PopUpWhatIsEsim';
import { prepareNewWindowUrl } from '../../../utilities/StringHelpers/StringHelpers';
import { getImageProps } from 'app/utilities/ImageProps';
import PopUpConfirmation from './PopUpConfirmation';

const GenericVas = (props) => {
  const [isShowPopUp, setPopUp] = useState(false);
  const [isShowPopUpBeforeCompletion, setPopUpBeforeCompletion] = useState(false);
  const [isCheckBoxConfirmed, setCheckBoxConfirmed] = useState(false);
  const [phoneData, setPhoneData] = useState(null);
  const isPrivateUser = props.isPrivate;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [isServiceAccessFormChecked, setIsServiceAccessFormChecked] = useState(false);
  const [serviceAccessFormError, setServiceAccessFormError] = useState('');

  const items = props?.contentData?.items?.expandedValue?.map((item) => {
    const privateIcon = getImageProps(item?.privateIcon, props?.context);
    const privateDescriptionText = item?.privateDescriptionText?.value;
    return {
      privateIcon,
      privateDescriptionText,
    };
  });

  const socType =
    props.contentData?.privateSocsList?.value !== null || props.contentData?.privateSocsList?.value !== undefined
      ? props.contentData?.privateSocsList?.value
      : null;

  const priceOrText = props?.contentData?.privatePrice?.value ? (
    <span className='priceText'>
      ₪<span>{isPrivateUser ? props.contentData.privatePrice.value : props.contentData.businessPriceText.value}</span> חד פעמי
    </span>
  ) : props?.contentData?.privateText?.value ? (
    <span className='only-text'>{props?.contentData?.privateText?.value}</span>
  ) : (
    ''
  );
  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    if (params.sub != undefined) {
      async function getCaptchaAndUserStatus() {
        props.showAppLoader();  
        let userStatus = await props.checkUserStatus({
          blockId: props.contentData.contentLink.id,
          subscriberNo: params.sub,
        });
        props.hideAppLoader();
        if (userStatus?.payload?.errorCode == undefined) {
          props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'visibility_1', eventLabel: analyticLabel() });
          if (isShowMinimumInfo()) {
            props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'visibility_2', eventLabel: analyticLabel() });
          }
          if (userStatus?.payload?.Body?.serviceAlreadyExist) {
            props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'visibility_3', eventLabel: 'element_1' });
          }
        } else {
          if (userStatus?.payload?.errorCode == 1062) {
            props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'visibility_4', eventLabel: 'element_2' });
          } else if (userStatus?.payload?.errorCode == 1063) {
            props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'visibility_5', eventLabel: 'element_3' });
          } else if (userStatus?.payload?.errorCode == 1061) {
            props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'visibility_6', eventLabel: 'element_4' });
          }
        }
      }
      getCaptchaAndUserStatus();
    }
    return () => {
      props.resetState();
    };
  }, []);

  const isShowMinimumInfo = () => {
    if (!props.serviceAlreadyExist) {
      if (legalText() == null && isShowTermsLinkByUser() == false) {
        return true;
      }
    }
    return false;
  };

  let termsAcceptHolder = (isAccepted) => {
    props.setIsShowConfirmTermsMsg(isAccepted);
    props.setTermAgreement(isAccepted);
    props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'click_1', eventLabel: analyticLabel() });
    setCheckBoxConfirmed(isAccepted);
  };

  async function installSocs() {
    props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'click_2', eventLabel: analyticLabel() });
    if (isShowMinimumInfo()) {
      props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'click_3', eventLabel: analyticLabel() });
    }

    if(props.contentData.isCheckServiceAccessForm.value && !props.isOpenForCalls && !isServiceAccessFormChecked){
      setServiceAccessFormError('חובה לאשר את הפעלת שירות שיחות לחו"ל');
    }
    else {
      setServiceAccessFormError('');
    }

    let isDisplayTerms = isShowTermsLinkByUser();

    if (isDisplayTerms) {
      if (props.isTermsAccepted && socType[0] !== 'UpgradeEsimAction') {
        saveGenericVAS();
      } else if (
        props.email.email != '' &&
        props.email.errors.email == '' &&
        props.email.errors.email != 'ערך לא תקין' &&
        props.isTermsAccepted
      ) {
        saveGenericVAS();
        props.setIsShowConfirmTermsMsg(false);
        props.setIsValidEmail(false);
      } else {
        if (props.isTermsAccepted) {
          props.setIsShowConfirmTermsMsg(false);
        } else {
          props.setIsShowConfirmTermsMsg(true);
          props.setIsValidEmail(true);
        }
      }
    } else {
      if (props.email.email != '' && props.email.errors.email == '' && props.email.errors.email != 'ערך לא תקין') {
        saveGenericVAS();
        props.setIsValidEmail(false);
      } else {
        props.setIsValidEmail(true);
      }
    }
  }

  async function saveGenericVAS() {
    if (props.contentData.isCheckServiceAccessForm.value && !props.isOpenForCalls && !isServiceAccessFormChecked) { return; }

    props.setIsValidEmail(false);
    props.showAppLoader();
    const token = await getRecaptchaToken('GenericVAS');
    if (token == undefined || token == null || token == '') return;
    let response = await props.saveGenericVAS({
      captchaToken: token,
      blockId: props.contentData.contentLink.id,
      subscriberNo: params.sub,
      socType: socType[0] == 'UpgradeEsimAction' ? socType[0] : null,
      email: props.email.email,
      socName: title(),
      isServiceAccessFormChecked: isServiceAccessFormChecked
    });
    if (response !== null) {
      setPhoneData(response);
    }
    props.hideAppLoader();
    if (response?.payload?.errorCode != undefined) {
      if (response.payload.errorCode == 1065) {
        props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'visibility_9', eventLabel: analyticLabel() });
      } else {
        props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'visibility_8', eventLabel: analyticLabel() });
      }
    } else {
      props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'visibility_7', eventLabel: analyticLabel() });

      if (props.contentData.isCheckServiceAccessForm.value && !props.isOpenForCalls) {
          props.reportDWH({ actionType: 'UserFormChange', status: 'Completed', messageText: 'User Form Changed Successfully' });
      }

    }
  }

  const onClickOtherSubscribersLink = () => {
    props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'click_4', eventLabel: analyticLabel() });
    if (isPrivateUser) {
      EpiContext.navigateTo(props.contentData.privateOtherSubscribersLink.value);
    } else {
      EpiContext.navigateTo(props.contentData.businessOtherSubscribersLink.value);
    }
  };

  const onClickMoreServicesLink = () => {
    props.reportAnalytics({ eventCategory: 'Sok_Generic', eventAction: 'click_5', eventLabel: analyticLabel() });
    if (isPrivateUser) {
      EpiContext.navigateTo(props.contentData.privateMoreServicesLink.value);
    } else {
      EpiContext.navigateTo(props.contentData.businessMoreServicesLink.value);
    }
  };

  const successPrivate = () => {
    return (
      <InstallSuccess
        phoneNumber={params.sub}
        phoneData={phoneData}
        contentData={props.contentData}
        context={props.context}
        successText={props.contentData.privateSuccessText.value}
        isShowMoreServicesLink={props.contentData.privateIsShowMoreServices.value}
        onClickMoreServicesLink={onClickMoreServicesLink}
        isShowOtherSubscribersLink={props.contentData.privateIsAllowForOtherSubscribers.value && props.numberOfSubscribers > 1}
        onClickOtherSubscribersLink={onClickOtherSubscribersLink}
        isPrivateUser={isPrivateUser}
      />
    );
  };

  const successBusiness = () => {
    return (
      <InstallSuccess
        phoneNumber={params.sub}
        phoneData={phoneData}
        contentData={props.contentData}
        context={props.context}
        successText={props.contentData.businessSuccessText.value}
        isShowMoreServicesLink={props.contentData.businessIsShowMoreServices.value}
        onClickMoreServicesLink={onClickMoreServicesLink}
        isShowOtherSubscribersLink={props.contentData.businessIsAllowForOtherSubscribers.value && props.numberOfSubscribers > 1}
        onClickOtherSubscribersLink={onClickOtherSubscribersLink}
        isPrivateUser={isPrivateUser}
      />
    );
  };

  const successView = () => {
    if (isPrivateUser) {
      return successPrivate();
    } else {
      return successBusiness();
    }
  };

  const isShowTermsLinkByUser = () => {
    if (isPrivateUser) {
      return props.contentData.privateIsShowTermsLink.value;
    } else {
      return props.contentData.businessIsShowTermsLink.value;
    }
  };

  const legalText = () => {
    let text = '';
    if (isPrivateUser) {
      text = props.contentData.privateLegalText.value;
    } else {
      text = props.contentData.businessLegalText.value;
    }
    return text != '' ? (
      <div className='law-block'>
        <Image src={require('./images/icon_shield.svg')} alt='חשוב שתדעו' />
        <div className='law-block-text'>
          <span>{text}</span>
        </div>
      </div>
    ) : null;
  };

  const insertEmail = () => {
    return (
      <>
        <div className='email-block'>
          <div className='email-text'>
            <p>לאיזה מייל לשלוח את הוראות ההפעלה ל-eSIM?</p>
          </div>
          <TextInput
            required='required'
            error={''}
            onChange={(e) => props.changeEmailInputHandler({ target: e.target, form: props.email })}
            value={props.email.email}
            name='email'
            type='email'
            placeholder='מייל'
            id='email'
          />
          {props.isInstallSocsClicked ? (
            <>
              {props.email.errors.email == 'ערך לא תקין' || props.email.email == '' || props.email.email == null ? (
                <div className='service-terms-warning email'>חובה להזין כתובת מייל תקינה</div>
              ) : null}
            </>
          ) : null}
        </div>
      </>
    );
  };

  const onClickErrorBtn = () => {
    EpiContext.navigateTo(Config.lobbyUrl);
  };

  const title = () => {
    if (isPrivateUser) {
      return props.contentData.privateTitle.value;
    } else {
      return props.contentData.businessTitle.value;
    }
  };

  const serviceName = () => {
    if (isPrivateUser) {
      return props.contentData.privateServiceName.value;
    } else {
      return props.contentData.businessServiceName.value;
    }
  };

  const analyticLabel = () => {
    return title() + '-' + serviceName();
  };

  const btnSubmit = () => {
    props.setIsInstallSocsClicked(true);

    if (!props.contentData.isPopUp.value) {
      installSocs();
    } else {
      if (!props.isShowConfirmPopUpTermsMsg) {
        props.setIsShowConfirmTermsMsg(true);
      }

      const errorsEmail = props.email.errors.email == 'ערך לא תקין' || props.email.email == '' || props.email.email == null;
      const isShowTermsLink = isShowTermsLinkByUser();
      if (((isShowTermsLink && isCheckBoxConfirmed) || !isShowTermsLink) && !errorsEmail) {
        setPopUpBeforeCompletion(true);
        props.setIsShowConfirmTermsMsg(false);
      }
    }
  };


  const confirmationClosePopUp = () => {
    setPopUpBeforeCompletion(false);
    props.setErrorConfirmPopUpTermsMsg('');
  };

  const btnPopUpConfirmation = () => {
    if (props.isShowConfirmPopUpTermsMsg) {
      installSocs();
      setPopUpBeforeCompletion(false);
      props.setIsShowConfirmPopUpTermsMsg(false);
    } else props.setErrorConfirmPopUpTermsMsg('כדי להמשיך יש לאשר שקראת את ההודעה');
  };

  const mainView = () => {
    return (
      <div className='generic-vas-container'>
        <div className='title'>{title()}</div>
        <div className='sub-title'>למנוי</div>
        <div className='phone-num'>{params.sub}</div>
        {socType[0] !== 'UpgradeEsimAction' ? (
          <div className='service-block'>
            <div className='service-name'>{serviceName()}</div>
            <div className='service-text'>
              {isPrivateUser ? props.contentData.privateDescriptionText?.value : props.contentData.businessDescriptionText?.value}
            </div>
            {props.serviceAlreadyExist ? null : (
              <div className='price-text'>
                {isPrivateUser ? props.contentData.privatePriceText?.value : props.contentData.businessPriceText?.value}
              </div>
            )}

            {props.contentData.isCheckServiceAccessForm.value && !props.isOpenForCalls &&
              <div className='service-access-form-text'>
                *לידיעתך, המנוי {params.sub} חסום לשירות שיחות לחו"ל. על מנת להפעיל שירות זה, נדרש לבצע שינוי בטופס הגישה לשירותים ביחס לקטגוריית שיחות לחו"ל. עם ביצוע ההזמנה, שירות השיחות לחו״ל יפתח וישאר פתוח כל עוד הלקוח לא ביקש לחסום אותו מחדש
              </div>
            }

          </div>
        ) : (
          <>
            <div className='serviceEsimContainer'>
              <Row xs='2'>
                <Col className='serviceNameContainer'>
                  <div className='serviceItem'>
                    <span className='serviceText'>{serviceName()}</span>
                  </div>
                </Col>
                {props.serviceAlreadyExist ? null : (
                  <Col className='serviceNameContainer'>
                    <div className='priceItem'>{priceOrText}</div>
                  </Col>
                )}
              </Row>
            </div>
            <div className='serviceContent'>
              <div className='itemContainer'>
                {items?.map((item, i) => {
                  return (
                    <span key={i} className='text-icon'>
                      {item?.privateIcon.src && <Image src={item?.privateIcon.src} alt={item?.privateIcon.alt} />}
                      <p>{item?.privateDescriptionText}</p>
                    </span>
                  );
                })}
              </div>
            </div>

            <div className='esimLinksContainer'>
              <h2 className='esimLinkText'>
                <a onClick={() => setPopUp(true)}>מה זה eSIM?</a>
              </h2>
              <h2 className='esimLinkText'>
                <a
                  onClick={() =>
                    prepareNewWindowUrl(props.contentData?.esimData?.expandedValue[0]?.cellularDevicesSupportedUrl?.value, props.context)
                  }>
                  מכשירים תומכים
                </a>
              </h2>
            </div>
            {insertEmail()}
          </>
        )}
        {props.serviceAlreadyExist ? (
          <div className='service-exist-block'>
            <div>
              <span>לקוח יקר, אין אפשרות להצטרף לשירות מאחר והשירות כבר קיים למנוי</span>
            </div>
          </div>
        ) : isShowTermsLinkByUser() ? (
          <div className='service-terms-wrapper'>

            <CheckBox
              id='serviceApproveTerms'
              label={<> <span>אני מאשר את</span> <a target='_blank' href={EpiContext.getEpiserverUrl(isPrivateUser ? props.contentData.privateTermsLink.value : props.contentData.businessTermsLink.value)}>תנאי השירות</a> </>}
              onCheck={() => { termsAcceptHolder(true) }}
              onUncheck={() => { termsAcceptHolder(false) }}
            />

            {props.isShowConfirmTermsMsg ? <div className='service-terms-error'> חובה לאשר את תנאי השירות </div> : null}
          </div>
        ) : null}

        {
          props.contentData.isCheckServiceAccessForm.value && !props.isOpenForCalls &&
          <div className='service-access-form-wrapper'>
            <CheckBox
              id='service-access-form'
              label={'אני מאשר/ת הפעלת שירות שיחות לחו"ל במנוי שלי'}
              onCheck={() => { setIsServiceAccessFormChecked(true); setServiceAccessFormError(''); }}
              onUncheck={() => { setIsServiceAccessFormChecked(false) }}
            />
            {serviceAccessFormError ? <div className='service-access-form-error'> {serviceAccessFormError} </div> : null}
          </div>
        }

        {props.serviceAlreadyExist ? null : (
          <BtnSubmit
            text={isPrivateUser ? props.contentData.privateButtonText.value : props.contentData.businessButtonText.value}
            onclick={btnSubmit}
          />
        )}

        <PopUp preventWrapperClose={true} showPopUp={isShowPopUp} onClose={() => setPopUp(false)} className='what-is-esim-popup'>
          <PopUpWhatIsEsim
            contentData={props.contentData}
            context={props.context}
            isPopUp={true}
            footerButton={<BtnSubmit onclick={() => setPopUp(false)} text='סגור' />}
          />
        </PopUp>
        <PopUp
          className='pop-up-confirmation'
          preventWrapperClose={true}
          showPopUp={isShowPopUpBeforeCompletion}
          onClose={confirmationClosePopUp}>
          <PopUpConfirmation
            isPopUp={true}
            contentData={props.contentData}
            footerButton={<BtnSubmit onclick={btnPopUpConfirmation} text='הבנתי, תודה' />}
          />
        </PopUp>
      </div>
    );
  };


  async function resendEsimEmail() {
    const errorsEmail = props.email.errors.email == 'ערך לא תקין' || props.email.email == '' || props.email.email == null;
    if (errorsEmail) {
      return;
    }
    if (params.sub != undefined) {
      props.showAppLoader();
      const token = await getRecaptchaToken('GenericVAS');
      if (token == undefined || token == null || token == '') {
        return;
      }
      await props.sendEmailHaveEsim({
        captchaToken: token,
        blockId: props.contentData.contentLink.id,
        subscriberNo: params.sub,
        socType: socType[0] == 'UpgradeEsimAction' ? socType[0] : null,
        email: props.email.email,
      });
      props.hideAppLoader();
    }
  }

  async function clickWhatsappBtn() {
    const whatsAppLink = `https://wa.me/${Config.whatsAppTechnicalService}`;
    let win = window.open(whatsAppLink, '_blank');
    win.focus();
  }


  const esimErrorView = () => {
    return (
      <div className='generic-vas-esim-error'>
        <Image src={require('./images/icon-hand.svg')} alt='' />
        <h1 className='title'>רק רגע</h1>
        <p className='sub-title'>קוד QR להפעלת eSIM כבר מחכה לך במייל
          יש לסרוק אותו להפעלת ה-eSIM במכשיר</p>
        <div className='email-block'>
          <div className='email-text'>
            <h3>שנשלח שוב?</h3>
          </div>
          {props.isSendEsimEmailSuccess ? <div className='resend-email-success'>קוד ה-QR נשלח למייל</div> :
            <div className='input-wrapper'>
              <TextInput
                required='required'
                error={props.email.errors.email}
                onChange={(e) => props.changeEmailInputHandler({ target: e.target, form: props.email })}
                value={props.email.email}
                name='email'
                type='email'
                placeholder='מייל'
                id='email'
              />
            </div>
          }
        </div>
        {!props.isSendEsimEmailSuccess && <BtnSubmit onclick={() => resendEsimEmail()} text='שלחו לי' />}
        <div className='whatsapp-wrapper'>
          <h3>משהו לא עובד?</h3>
          <BtnWhiteBlackBorderBigSize
            formid='failure-screen'
            onclick={() => clickWhatsappBtn()}
            text={<span>נשמח לעזור ב-WhatsApp <Image src={require('./images/icon-whatsapp.svg')} /></span>}></BtnWhiteBlackBorderBigSize>
        </div>
      </div>
    );
  }

  return (
    <div className='generic-vas-block'>
      {props.isShowMainView && mainView()}
      {props.isShowEsimError && esimErrorView()}
      {props.error.isDisplay && <FailureScreen errorId={props.error.id} onclick={() => onClickErrorBtn()} />}
      {props.isShowSuccessView ? successView() : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    responseComponent: state.genericVasBlock.responseComponent,
    isPrivate: state.genericVasBlock.isPrivate,
    isTermsAccepted: state.genericVasBlock.isTermsAccepted,
    isShowConfirmTermsMsg: state.genericVasBlock.isShowConfirmTermsMsg,
    isShowConfirmPopUpTermsMsg: state.genericVasBlock.isShowConfirmPopUpTermsMsg,
    error: state.genericVasBlock.error,
    isShowSuccessView: state.genericVasBlock.isShowSuccessView,
    serviceAlreadyExist: state.genericVasBlock.serviceAlreadyExist,
    isShowMainView: state.genericVasBlock.isShowMainView,
    numberOfSubscribers: state.genericVasBlock.numberOfSubscribers,
    email: state.genericVasBlock.email,
    isValidEmail: state.genericVasBlock.isValidEmail,
    isInstallSocsClicked: state.genericVasBlock.isInstallSocsClicked,
    isShowEsimError: state.genericVasBlock.isShowEsimError,
    isSendEsimEmailSuccess: state.genericVasBlock.isSendEsimEmailSuccess,
    isOpenForCalls: state.genericVasBlock.isOpenForCalls
  };
};

const mapDispatchToProps = {
  saveGenericVAS,
  checkUserStatus,
  setTermAgreement,
  setIsShowConfirmTermsMsg,
  setIsShowConfirmPopUpTermsMsg,
  setErrorConfirmPopUpTermsMsg,
  showAppLoader,
  hideAppLoader,
  reportAnalytics,
  reportDWH,
  changeEmailInputHandler,
  setIsValidEmail,
  setIsInstallSocsClicked,
  sendEmailHaveEsim,
  resetState,
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericVas);
